import React from 'react';
import { Scale } from 'lucide-react';
const costs = [{
  without: 'Meses buscando información dispersa',
  cost: 'Tiempo que nunca recuperás'
}, {
  without: 'Reuniones sin sistema ni material',
  cost: 'Propiedades que se pierden'
}, {
  without: 'Cobrar en pesos pudiendo cobrar en USD',
  cost: 'Pérdida real de valor cada mes'
}, {
  without: 'Sin contrato ni protocolo',
  cost: 'Conflictos sin documentación que te proteja'
}, {
  without: 'El próximo mes sin ingresos en USD',
  cost: 'El mismo ciclo, sin avance'
}];
export function CostComparison() {
  return <section className="py-20 bg-white" data-id="element-61">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <h2 className="text-3xl font-bold text-gray-900 flex items-center justify-center gap-3" data-id="element-64">
            <Scale className="w-8 h-8 text-gray-400" data-id="element-65" />
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="overflow-x-auto mb-12 pb-4" data-id="element-66">
          <table className="w-full min-w-[500px] border-collapse bg-white rounded-2xl overflow-hidden border border-gray-200" data-id="element-67">
            <thead data-id="element-68">
              <tr data-id="element-69">
                <th className="text-left p-4 bg-gray-50 text-gray-600 font-semibold border-b border-gray-200 w-1/2" data-id="element-70">
                  Sin Megapack
                </th>
                <th className="text-left p-4 bg-red-50 text-red-700 font-semibold border-b border-red-100 w-1/2" data-id="element-71">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-72">
              {costs.map((row, i) => <tr key={i} className="border-b border-gray-100 last:border-0 hover:bg-gray-50/50" data-id="element-73">
                  <td className="p-4 text-gray-600 text-sm" data-id="element-74">{row.without}</td>
                  <td className="p-4 text-red-600 font-medium text-sm" data-id="element-75">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-76">
          <p className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-77">
            El próximo mes puede ser el primero con ingresos en dólares.
          </p>
        </div>
      </div>
    </section>;
}